import * as React from 'react';

export default function FeaturedFeatures ( props ) {

  let color_class = 'text-master';
  switch ( props.app.featuredAmenities ) {
  case 1:
  case '1':
    color_class = '\ text-white';
    break;
  case 2:
  case '2':
    color_class = '\ text-master';
    break;
  case 3:
  case '3':
    color_class = '\ text-design-color';
    break;
  default:
    color_class = '\ text-master';
    break;
  }

  return (
    <div className="row mt-4">
      {
        props.featured_features.map( ( feature ) => (
          <div key={feature.feature_id.toString()} className={props.fourColumns ? 'col-6 col-md-3' : 'col-6 col-md-4'}>
            <p>
              <i className={feature.feature_font_icon_new + color_class + '\ m-r-10'} /> {feature.feature_title}
            </p>
          </div>
        ) )
      }
    </div>
  )
}
